import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserState {
  token?: string;
}

const initialState: UserState = {
  token: undefined,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<UserState['token']>) => {
      state.token = action.payload;
    },
  },
});

export default userSlice.reducer;